(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const initSection = (section) => {
      if (initialized.has(section)) return;
      initialized.add(section);

      const slides = Array.from(section.querySelectorAll('[data-footer-announcement-slide]'));
      const previousButton = section.querySelector('[data-footer-announcement-previous]');
      const nextButton = section.querySelector('[data-footer-announcement-next]');

      if (!slides.length) return;

      let activeIndex = 0;

      const setActive = (index) => {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== activeIndex;
        });
      };

      if (slides.length < 2) {
        previousButton?.setAttribute('disabled', '');
        nextButton?.setAttribute('disabled', '');
      }

      previousButton?.addEventListener('click', () => setActive(activeIndex - 1));
      nextButton?.addEventListener('click', () => setActive(activeIndex + 1));
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-footer-announcement-bar]').forEach(initSection);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-publicacoes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const pauseVideos = (slides) => {
      slides.forEach((slide) => {
        slide.querySelectorAll('video').forEach((video) => {
          video.pause();
        });
      });
    };

    const initSection = (section) => {
      if (initialized.has(section)) return;
      initialized.add(section);

      const modal = section.querySelector('[data-instagram-modal]');
      const triggers = Array.from(section.querySelectorAll('[data-instagram-trigger]'));
      const slides = Array.from(section.querySelectorAll('[data-instagram-slide]'));
      const captions = Array.from(section.querySelectorAll('[data-instagram-caption]'));
      const dots = Array.from(section.querySelectorAll('[data-instagram-dot]'));
      const current = section.querySelector('[data-instagram-current]');
      const closeButton = section.querySelector('[data-instagram-close]');
      const previousButton = section.querySelector('[data-instagram-previous]');
      const nextButton = section.querySelector('[data-instagram-next]');

      if (!modal || !slides.length) return;

      let activeIndex = 0;

      const setActive = (index) => {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== activeIndex;
        });

        captions.forEach((caption, captionIndex) => {
          caption.hidden = captionIndex !== activeIndex;
        });

        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-selected', dotIndex === activeIndex ? 'true' : 'false');
        });

        if (current) current.textContent = String(activeIndex + 1);

        pauseVideos(slides);

        const activeVideo = slides[activeIndex].querySelector('video');
        if (activeVideo) {
          activeVideo.currentTime = 0;
          activeVideo.play().catch(() => {});
        }
      };

      const openModal = (index) => {
        setActive(index);
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
        document.documentElement.classList.add('instagram-publicacoes-modal-open');
      };

      const closeModal = () => {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          openModal(Number(trigger.dataset.instagramIndex || 0));
        });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          setActive(Number(dot.dataset.instagramIndex || 0));
        });
      });

      previousButton?.addEventListener('click', () => setActive(activeIndex - 1));
      nextButton?.addEventListener('click', () => setActive(activeIndex + 1));
      closeButton?.addEventListener('click', closeModal);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });

      modal.addEventListener('close', () => {
        pauseVideos(slides);
        document.documentElement.classList.remove('instagram-publicacoes-modal-open');
      });

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
        if (event.key === 'ArrowRight') setActive(activeIndex + 1);
      });
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-instagram-publicacoes]').forEach(initSection);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
